import { classNames } from '@progress/kendo-react-common';
import { FieldRenderProps, FieldWrapper as KendoFieldWrapper, FieldWrapperProps as KendoFieldWrapperProps } from '@progress/kendo-react-form';
import { Error } from '@progress/kendo-react-labels';
import { Label } from 'components';
import styles from './FieldWrapper.module.scss';

export type FieldWrapperProps = {
    label?: string,
    labelClassName?: string,
    required?: boolean
} & KendoFieldWrapperProps & FieldRenderProps;

export const FieldWrapper = (props: FieldWrapperProps) => {
    const { children, disabled, label, labelClassName, name, required, touched, valid, validationMessage, ...rest} = props;
    const error = touched && validationMessage;

    return (
        <KendoFieldWrapper className={styles.wrapper} {...rest}>
            {label && (
                <Label
                    className={classNames(styles.label, labelClassName)}
                    editorId={name}
                    editorDisabled={disabled}
                    editorValid={valid}
                    id={`${name}_label`}
                    required={required}
                >
                    {label}
                </Label>
            )}
            {children}
            {error && <Error id={`${name}_error`}>{validationMessage}</Error>}
        </KendoFieldWrapper>
    );
};